import React, { useState,useEffect } from 'react'
import i18n from '@dhis2/d2-i18n'
import classes from '../../App.module.css'
import { makeStyles } from '@material-ui/core/styles';
import { apiServices } from '../../services/apiServices'
import SearchBar from '../../component/searchbar/SearchBar';
import CaseList from './NewThemeCaseList'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Pagination from "@material-ui/lab/Pagination";
import Grid from '@material-ui/core/Grid';
import { useHistory, useLocation } from 'react-router-dom';
import {
    Button, 
    ButtonStrip,
    Divider,
    InputFieldFF, 
    SingleSelectFieldFF, 
    ReactFinalForm,
    hasValue,
    InputField,
    CircularLoader,
    CenteredContent
} from '@dhis2/ui';
import { withTranslation, Trans , useTranslation } from 'react-i18next';
import swal from 'sweetalert'
import OfflineDb from '../../db'
import {useGlobalSpinnerActionsContext} from '../../context/GlobalSpinnerContext'
//import {Configuration} from '../../assets/data/config'
import '../../assets/css/customstyles.css'
import '../../assets/css/theme_grey.css'
import '../../assets/css/theme_blue.css'
import '../../assets/css/theme_green.css'
import '../../assets/css/theme_red.css'

import FooterMenu from '../../component/layout/FooterMenu'

const {Form, Field } = ReactFinalForm

function Cases(){
    const history = useHistory();
    const location = useLocation();
    const [sessionUserBoValue,setSessionUserBoValue] = React.useState(null)
    const [progarmData,setProgarmData] = useState(null)
    const [customSearch,setCustomSearch] = useState([])
    const [UICSearch,setUICSearch] = useState([])
    const [input, setInput] = useState('');
    const [searchResult,setSearchResult] = useState([])
    const [searchAllResult,setSearchAllResult] = useState([])
    const [value,setValue] = useState([])
    // const [loading,setGlobalSpinner] = useState(false)
    const {t} = useTranslation()
    const [viewType, setViweType] = useState('list')
    const setGlobalSpinner = useGlobalSpinnerActionsContext()

    //pagination code
    //const itemsPerPage = Configuration.pagination.itemsPerPage
    const [page, setPage] = useState(1);
    const [noOfPages,setNoOfPages] = useState(0)
    const [Configuration,setConfiguration] = useState(null);
    const [totalPages, setTotalPages] = useState(null)
    const [start, setstart] = useState(1);
    const [filterType, setFilterType] = useState("RegisteredBy")
    async function getMetaData(){
        let metadata = await OfflineDb.getDataFromPouchDB('metaData')
        setProgarmData(metadata.data)
        
        let loginDetails = await OfflineDb.getDataFromPouchDB('loginDetails')
        setSessionUserBoValue(loginDetails.data)

        let configurations = await OfflineDb.getDataFromPouchDB('configurations')
        setConfiguration(configurations.data.configuration)
    }
    useEffect(()=>{
        getMetaData()      
        OfflineDb.removeDataFromPouchDB('activeCaseDetails')
        OfflineDb.removeDataFromPouchDB('activeCaseFormData')
        OfflineDb.removeDataFromPouchDB('linkContactFlag')
        OfflineDb.setDataIntoPouchDB('transferFlag', {type:null})
        if(localStorage.getItem('referral-type')){
            localStorage.removeItem('referral-type')
        }

    },[])
    useEffect(()=>{
        try{
            if(location && location.search && page){
                const params = new URLSearchParams(location.search);
                const clientPage = params.get('page');
                const type = params.get('type');
                setFilterType(type)
                if(page != clientPage){
                    setPage(Number(clientPage))
                    setstart(Number(clientPage))
                }
                // let pageNumber = location.search.split('&')
                //let params = pageNumber.split('=')
                // console.log("pageNumber ",pageNumber,location)
                // if(params && params.length > 0){
                //     if(params[1] == "RegisteredBy"){

                //     }
                // }
                // else if(pageNumber && pageNumber.length > 0 && page != pageNumber[1]){
                //     setPage(Number(pageNumber[1]))
                //     setstart(Number(pageNumber[1]))
                // }
            }
        }catch(e){
            console.log(e)
        }
    },[location])
    //once user bco is set call getContactList function
    useEffect(()=>{
        if(sessionUserBoValue != null && Configuration != null){
            console.log("vv ",page,start,filterType)
            if(navigator.onLine){
                if(filterType == "RegisteredBy"){
                    getCasesList()
                }else{
                    getServiceByList()
                }
                
            }else{
                swal({
                    title: "Error",
                    text: t("Client list could not be shown in offline mode."),
                    icon: "error",
                    button: "Close",
                }).then(alertRes => {
                    history.push('/layout/home')
                });
            }
        }
    },[sessionUserBoValue, Configuration])
    useEffect(()=>{
        if(searchResult && searchResult.length >= 2 && Configuration != null){
            setNoOfPages(Math.ceil(searchResult[1].length / Configuration.pagination.itemsPerPage))
        }
        if(totalPages != null){
            setNoOfPages(totalPages)
        }
    },[searchResult,Configuration,totalPages])
    
    function getCasesList(param,startPageNo,globalsearch)  {
        if(navigator.onLine){
        //localStorage.removeItem('trackedEntityInstance')
        setGlobalSpinner(true)  
        const allOU = sessionUserBoValue ? sessionUserBoValue ? sessionUserBoValue.organisationUnits : sessionUserBoValue.organisationUnits[0].id : sessionUserBoValue.organisationUnits[0].id;
        let hotspots = null;
        if(allOU){
            //allOU = _.filter(allOU,{"level":6})
            allOU.map((hotspot, i) => {
                //if(hotspot["level"] && hotspot["level"] == 6){
                    if(hotspots){
                        hotspots = hotspots+';'+hotspot.id
                    }else{
                        hotspots = hotspot.id
                    }
                    
                //}
            })
        }
        let loggedInUsername = sessionUserBoValue.username
        let OU = hotspots ? hotspots : sessionUserBoValue.organisationUnits[0].id      
        let orgID = OU,//sessionUserBoValue.organisationUnits[0].id, //`UuYrI1twhmN`,
            programID = sessionUserBoValue.programs[0], //`nSy7PFqQykt`, 
            searchQuery = ``
        let pageNo = startPageNo ? startPageNo : start
        for (var i in param) {
            searchQuery += `&attribute=${i}:LIKE:${param[i]}`
        }
        
        let subURL = 'trackedEntityInstances/query.json?attribute=UWjV6MJKAHJ:EQ:'+loggedInUsername+'&ou='+ orgID +'&ouMode=SELECTED&order=created:desc&program='+ programID +'&pageSize='+Configuration.pagination.itemsPerPage+'&page='+pageNo+'&totalPages=true&skipPaging=false'
                   //'trackedEntityInstances/query.json?ou='+ orgID +'&ouMode=SELECTED&&order=created:desc&program='+ programID +'&pageSize=50&page=1&totalPages=false'
                   //&pageSize=50&page=1&totalPages=false
        if (sessionUserBoValue.userRoles && 
             sessionUserBoValue.userRoles.find(item => item.name =='Data  Administrator')
        ){
            subURL = 'trackedEntityInstances/query.json?&ou='+ orgID +'&ouMode=ACCESSIBLE&order=created:desc&program='+ programID +'&pageSize='+Configuration.pagination.itemsPerPage+'&page='+pageNo+'&totalPages=true&skipPaging=false'

        }
        if(globalsearch){
            subURL = 'trackedEntityInstances/query.json?attribute=UWjV6MJKAHJ:EQ:'+loggedInUsername+'&attribute=PeodlfJ86FN:LIKE:'+globalsearch+'&ou='+ orgID +'&ouMode=SELECTED&order=created:desc&program='+ programID +'&totalPages=true&skipPaging=true'
        }
        apiServices.getAPI(subURL).then(res => { 
            if(res.data  && res.data.metaData && res.data.metaData.pager  && res.data.metaData.pager.pageCount){
                setTotalPages(res.data.metaData.pager.pageCount)
            }
            let searchArray = []
            searchArray.push(res.data.headers)
            try{
                res.data.rows.sort(function(a, b) { 
                    return a[2] < b[2] ? 1 : -1;
                });
                //console.log("res.data.rows ",res.data.rows);
            }catch(e){

            }
            searchArray.push(res.data.rows)
            setGlobalSpinner(false)
            setSearchResult(searchArray)
            setSearchAllResult(searchArray)
            OfflineDb.setDataIntoPouchDB('myclients',searchArray);
        }).catch(error => {
            setGlobalSpinner(false)
            swal({
                title: t("Error"),
                text: error,
                icon: "error",
                button: t("Close"),
              });
        })
        
        }else{
            swal({
                title: "Error",
                text: t("Client list could not be shown in offline mode."),
                icon: "error",
                button: "Close",
            }).then(alertRes => {
                history.push('/layout/home')
            });
        }
    }
    
    function getServiceByList(param,startPageNo,globalsearch)  {
        if(navigator.onLine){
        //localStorage.removeItem('trackedEntityInstance')
        setGlobalSpinner(true)  
        const allOU = sessionUserBoValue ? sessionUserBoValue ? sessionUserBoValue.organisationUnits : sessionUserBoValue.organisationUnits[0].id : sessionUserBoValue.organisationUnits[0].id;
        let hotspots = null;
        if(allOU){
            //allOU = _.filter(allOU,{"level":6})
            allOU.map((hotspot, i) => {
                //if(hotspot["level"] && hotspot["level"] == 6){
                    if(hotspots){
                        hotspots = hotspots+';'+hotspot.id
                    }else{
                        hotspots = hotspot.id
                    }
                    
                //}
            })
        }
        let loggedInUsername = sessionUserBoValue.username
        let OU = hotspots ? hotspots : sessionUserBoValue.organisationUnits[0].id      
        let orgID = OU,//sessionUserBoValue.organisationUnits[0].id, //`UuYrI1twhmN`,
            programID = sessionUserBoValue.programs[0], //`nSy7PFqQykt`, 
            searchQuery = ``
        let pageNo = startPageNo ? startPageNo : start
        for (var i in param) {
            searchQuery += `&attribute=${i}:LIKE:${param[i]}`
        }
        //29/sqlViews/DxhffRsTkE6/data?paging=true&pageSize=50&page=1
        apiServices.postAPI("29/sqlViews/DxhffRsTkE6/execute").then(res => { 
                let subURL = '29/sqlViews/DxhffRsTkE6/data?paging=true&pageSize='+Configuration.pagination.itemsPerPage+'&page='+pageNo+'&Criteria=storedby:'+sessionUserBoValue.userCredentials.id
                if(globalsearch){
                    //&filter="Nick Name":ilike:Dor
                    subURL = '29/sqlViews/DxhffRsTkE6/data?&Criteria=storedby:'+sessionUserBoValue.userCredentials.id+'&filter="Nick Name":ilike:'+globalsearch
                }
                   //'trackedEntityInstances/query.json?ou='+ orgID +'&ouMode=SELECTED&&order=created:desc&program='+ programID +'&pageSize=50&page=1&totalPages=false'
                   //&pageSize=50&page=1&totalPages=false
                apiServices.getAPI(subURL).then(res => { 
                    if(res.data  && res.data.pager  && res.data.pager.pageCount){
                        setTotalPages(res.data.pager.pageCount)
                    }
                    if(res.data && res.data.listGrid && res.data.listGrid.rows && res.data.listGrid.rows.length > 0){
                        let searchArray = []
                        searchArray.push(res.data.listGrid.headers)
                        try{
                            res.data.listGrid.rows.sort(function(a, b) { 
                                return a[2] < b[2] ? 1 : -1;
                            });
                            //console.log("res.data.rows ",res.data.rows);
                        }catch(e){

                        }
                        searchArray.push(res.data.listGrid.rows)
                        setGlobalSpinner(false)
                        setSearchResult(searchArray)
                        setSearchAllResult(searchArray)
                        OfflineDb.setDataIntoPouchDB('myclients',searchArray);
                    }else{
                        setSearchResult([])
                        setSearchAllResult([])
                    }
                    setGlobalSpinner(false)
                }).catch(error => {
                    setGlobalSpinner(false)
                    swal({
                        title: t("Error"),
                        text: error,
                        icon: "error",
                        button: t("Close"),
                    });
                })
            }).catch(error => {
                setGlobalSpinner(false)
                swal({
                    title: t("Error"),
                    text: error,
                    icon: "error",
                    button: t("Close"),
                });
            })
       
        }else{
            swal({
                title: "Error",
                text: t("Client list could not be shown in offline mode."),
                icon: "error",
                button: "Close",
            }).then(alertRes => {
                history.push('/layout/home')
            });
        } 
    }
    const handleViewChange = (event,newValue) => {
        setViweType(newValue);
    };
    
    const updateInput = (input) => {
        setInput(input);
        let filteredList = []
        setGlobalSpinner(true)
        if(input && input.length >= 3){
            // searchAllResult[1].map(function(objectKey, index) {
            //     let dataExist = false
            //     objectKey.map(function(data, j) {
            //         if(data.toLowerCase().indexOf(input.toLowerCase()) > -1 && !dataExist){
            //             filteredList.push(objectKey);
            //             dataExist = true;
            //         }
            //     })
            // })
            // let headerEle = searchAllResult[0]
            // let filterSearchArray = [];
            // filterSearchArray.push(headerEle)
            // filterSearchArray.push(filteredList)
            setSearchResult([]);
            setTimeout(function(){
                setTotalPages(1)
                if(filterType == "RegisteredBy"){
                    getCasesList({},1,input)
                }else{
                    getServiceByList({},1,input)
                    // setGlobalSpinner(false)
                    // setSearchResult(filterSearchArray)
                }
            },500)
        }else{
            if(input.length == 0){
                let headerEle = searchAllResult[0]
                let filterSearchArray = [];
                filterSearchArray.push(headerEle)
                filterSearchArray.push(searchAllResult[1])
                setSearchResult([]);
                setTimeout(function(){
                    if(filterType == "RegisteredBy"){
                        getCasesList({},1)
                    }else{
                        getServiceByList({},1)
                        // setGlobalSpinner(false)
                        // setSearchResult(filterSearchArray)
                    }
                },1000)
            }else{
                setGlobalSpinner(false)
            }
        }

        //if(filteredList.length > 0){
            
        
        
    }
   
    const loadViewToggleButtons = ()=>{
        return (
            <div className=" customregistrationtabs regcasetabs ">
                <AppBar position="static">
                    <Tabs value={viewType} onChange={handleViewChange}>
                        <Tab value="list" label={t('List View')}></Tab>
                        <Tab value="card" label= {t('Card View')}></Tab>
                    </Tabs>
                </AppBar>
            </div>
            
        )
    }
    const handlePageChange = (event, value) => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('page', value);
        searchParams.set('type', filterType);
        setstart(value)
        history.push({
            pathname: location.pathname,
            search: `?${searchParams.toString()}`,
          });
        setPage(value);
        setSearchResult([])
        setTimeout(function(){
            if(filterType == "RegisteredBy"){
                getCasesList({},value)
            }else{
                getServiceByList({},value)
            }
        },100)
    }

    const handleChange = (event) => {
        setInput('')
        setFilterType(event.target.value)
        setTotalPages(null)
        setPage(1)
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('page', 1);
        searchParams.set('type', event.target.value);
        history.push({
            pathname: location.pathname,
            search: `?${searchParams.toString()}`,
          });
        if (event.target.value == "RegisteredBy") {
            setSearchResult([])
            setTimeout(function(){
                getCasesList({},1)
            },100)
        }else if(event.target.value == "ServicedBy"){
            setSearchResult([])
            setTimeout(function(){
                getServiceByList({},1)
            },100)
        }
    };

    const filterClients = () => {
        const uniqueTypes = ["Registered By","Serviced By"];
    
        return (
          <div>
            <FormControl className={classes.formControl}>
              <InputLabel id="demo-simple-select-label">{t('Please select')}</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={filterType}
                onChange={handleChange}
              >
                {uniqueTypes.map(item => {
                  return (<MenuItem value={item.replace(" ","")}>{t(item)}</MenuItem>)
                })}
              </Select>
            </FormControl>
    
          </div>
        );
      }
    return (            
        <section className="searchcustombg searchtabmaindiv myclientspage"
                style={{
                    // backgroundColor: '#fff',
                    flexGrow: 1,
                    padding: 0,
                    
                }}
        >
            
            <FooterMenu></FooterMenu>
            <div className="searchformcontainer">
                {/* <p className="searchformheading">
                    <span><Trans>My Clients</Trans></span>
                    <div className="choose_alertdiv hide1">{ progarmData != null ? filterClients() : null}</div>
                </p> */}
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={8} md={10} className="">
                    <p className="searchformheading" style={{paddingLeft:"0px"}}>{t("My Clients")}</p>
                    </Grid>
                    <Grid item xs={12} sm={4} md={2}>
                    <div className="choose_alertdiv">{filterClients()}</div>
                    </Grid>
                </Grid>
                <SearchBar 
                input={input} 
                setKeyword={updateInput}
                />
                
                {searchResult.length > 0 ? loadViewToggleButtons() : null}
                {/*console.log('searchResult', searchResult)*/}
                {
                    
                    searchResult.length > 0  && progarmData != null && Configuration != null?                          
                        <CaseList
                            searchResult = {searchResult}
                            viewType={viewType}
                            metaData={progarmData}
                            page={page}
                            itemsPerPage={Configuration.pagination.itemsPerPage}
                            caseType={filterType}
                        /> : null
                }
                
                <Pagination
                    count={noOfPages}
                    page={page}
                    onChange={handlePageChange}
                    defaultPage={1}
                    //color="primary"
                    size="large"
                    showFirstButton
                    showLastButton
                    variant="outlined" 
                    shape="rounded" 
                />
                
            </div>
                          
        </section>
    )
    
}
export default Cases;